import React, { useMemo, useRef } from 'react';
import classNames from 'classnames';
import EfImg from '@elem/ui/ef-img';
import { Pagination, Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import styles from './index.module.scss';
import useSwiperAnimate from './useSwiperAnimate';

interface NextGenSwiperProps {
    className?: string;
    list: {
        pc: string;
        pad?: string;
        h5?: string;
    }[];

    playOptions?: {
        // 轮播？
        autoPlay?: boolean;
        // 轮播时间
        duration?: number;
    };
}

const DEFAULT_PLAY_OPTIONS = {
    autoPlay: false,
    duration: 3000,
};

const NextGenSwiper: React.FC<NextGenSwiperProps> = ({ className, list, playOptions }) => {
    const currentPlayOptions = useMemo(
        () => ({
            ...DEFAULT_PLAY_OPTIONS,
            ...playOptions,
        }),
        [playOptions],
    );
    const { slideChangeHandle, hanldleMouseEnter, hanldleMouseLeave, changeSwiper } = useSwiperAnimate({
        length: list.length,
        duration: currentPlayOptions.duration,
        swiperClassName: 'ef-NextGen-swiper',
        autoPlay: currentPlayOptions.autoPlay,
    });

    const prevRef = useRef<HTMLDivElement | null>(null);
    const nextRef = useRef<HTMLDivElement | null>(null);

    return (
        <div className={classNames('ef-NextGen-swiper-container', className, styles.TheComp)}>
            <Swiper
                className="ef-NextGen-swiper"
                modules={[Pagination, Navigation]}
                spaceBetween={0}
                loop
                autoplay
                navigation={{
                    prevEl: prevRef.current,
                    nextEl: nextRef.current,
                }}
                initialSlide={0}
                pagination={list.length > 1 ? { clickable: true } : false}
                onSlideChange={slideChangeHandle}
                onSwiper={changeSwiper}
            >
                {list.map((item, idx) => (
                    <SwiperSlide
                        className={`ef-NextGen-swiper-item ef-NextGen-swiper-item-${idx}`}
                        onMouseEnter={hanldleMouseEnter}
                        onMouseLeave={hanldleMouseLeave}
                        key={idx}
                    >
                        <EfImg pc={item.pc} pad={item.pad} h5={item.h5} />
                    </SwiperSlide>
                ))}
            </Swiper>
            <div className="ef-NextGen-swiper-navigations">
                <div className="ef-NextGen-swiper-navigation ef-NextGen-swiper-navigation-prev" ref={prevRef}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">
                        <path d="M7 1L1 7L7 13" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>
                <div className="ef-NextGen-swiper-navigation ef-NextGen-swiper-navigation-next" ref={nextRef}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">
                        <path d="M1 1L7 7L0.999999 13" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>
            </div>
        </div>
    );
};
export default NextGenSwiper;
